module.exports = __webpack_public_path__ + "static/media/BoxPlotQ5_3.e727c832.svg";